import { getApiClient } from "../client";
/** Custom Strapi controllers answer `{ data }`. */
const unwrap = (body) => body.data;
export const connectorsEndpoints = {
    async getConnector(exchangeAccountId) {
        const response = await getApiClient().get(`/exchange-accounts/${exchangeAccountId}/connector`);
        return unwrap(response.data);
    },
    /** Starts a native connection test. A test still running after ~50s answers { pending } (proxies cut at 60s). */
    async startConnectorTest(exchangeAccountId) {
        const response = await getApiClient().post(`/exchange-accounts/${exchangeAccountId}/connector/test`);
        return unwrap(response.data);
    },
    /** Runs a native connection test to completion: a pending test is followed through getConnector until stored. */
    async testConnector(exchangeAccountId, options = {}) {
        const started = await connectorsEndpoints.startConnectorTest(exchangeAccountId);
        if (!("pending" in started))
            return started;
        const since = new Date(started.startedAt).getTime();
        const deadline = Date.now() + (options.timeoutMs ?? 150000);
        while (Date.now() < deadline) {
            await new Promise((resolve) => setTimeout(resolve, options.pollMs ?? 5000));
            const { info } = await connectorsEndpoints.getConnector(exchangeAccountId);
            if (info.lastTest && new Date(info.lastTest.createdAt).getTime() >= since)
                return info.lastTest;
        }
        throw new Error("The connection test is still running; refresh in a minute to see its result");
    },
    async setConnector(exchangeAccountId, input) {
        const response = await getApiClient().put(`/exchange-accounts/${exchangeAccountId}/connector`, { data: input });
        return unwrap(response.data);
    },
    async clearFallback(exchangeAccountId) {
        const response = await getApiClient().post(`/exchange-accounts/${exchangeAccountId}/connector/clear-fallback`);
        return unwrap(response.data);
    },
    async listConnectors() {
        const response = await getApiClient().get("/connectors");
        return unwrap(response.data);
    },
    async listMigrations() {
        const response = await getApiClient().get("/connectors/migrations");
        return unwrap(response.data);
    },
    async createMigration(input) {
        const response = await getApiClient().post("/connectors/migrations", { data: input });
        return unwrap(response.data);
    },
    async controlMigration(batchId, action) {
        const response = await getApiClient().post(`/connectors/migrations/${batchId}/${action}`);
        return unwrap(response.data);
    },
    async listIncidents(filter = {}) {
        const response = await getApiClient().get("/connectors/incidents", { params: filter });
        return unwrap(response.data);
    },
    async acknowledgeIncidents(input) {
        const response = await getApiClient().post("/connectors/incidents/acknowledge", { data: input });
        return unwrap(response.data);
    },
    async listServerBuilds() {
        const response = await getApiClient().get("/connectors/server-builds");
        return unwrap(response.data);
    },
    async acknowledgeServerBuild(input) {
        const response = await getApiClient().post("/connectors/server-builds/acknowledge", { data: input });
        return unwrap(response.data);
    },
};
